export const URI_BLOG = 'blog';
